import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    ListRequiredDesignFileTemplatesParams,
    RequiredDesignFileTemplateListItem,
    RequiredDesignFileTemplatePreviewMatchRequest,
    RequiredDesignFileTemplatePreviewMatchResult,
    RequiredDesignFileTemplateRequest,
    RequiredDesignFileTemplateResponse,
} from '../model/required-design-file-template';

const basePath = '/api/required-design-file-templates';

@Injectable({ providedIn: 'root' })
export class RequiredDesignFileTemplateClient {
    private readonly _httpClient = inject(HttpClient);

    list(
        params: ListRequiredDesignFileTemplatesParams
    ): Observable<RequiredDesignFileTemplateListItem[]> {
        let httpParams = new HttpParams();
        if (params.treatmentTypeOriginalId != null) {
            httpParams = httpParams.set(
                'treatmentTypeOriginalId',
                String(params.treatmentTypeOriginalId)
            );
        }
        if (params.treatmentSubTypeOriginalId != null) {
            httpParams = httpParams.set(
                'treatmentSubTypeOriginalId',
                String(params.treatmentSubTypeOriginalId)
            );
        }
        if (params.organizationId != null) {
            httpParams = httpParams.set('organizationId', params.organizationId);
        }
        if (params.officeId != null) {
            httpParams = httpParams.set('officeId', params.officeId);
        }
        if (params.region != null) {
            httpParams = httpParams.set('region', String(params.region));
        }
        if (params.isActive != null) {
            httpParams = httpParams.set('isActive', String(params.isActive));
        }
        if (params.search != null && params.search.length > 0) {
            httpParams = httpParams.set('search', params.search);
        }

        return this._httpClient.get<RequiredDesignFileTemplateListItem[]>(basePath, {
            params: httpParams,
        });
    }

    getById(id: number): Observable<RequiredDesignFileTemplateResponse> {
        return this._httpClient.get<RequiredDesignFileTemplateResponse>(`${basePath}/${id}`);
    }

    create(model: RequiredDesignFileTemplateRequest): Observable<RequiredDesignFileTemplateResponse> {
        return this._httpClient.post<RequiredDesignFileTemplateResponse>(basePath, model);
    }

    update(
        id: number,
        model: RequiredDesignFileTemplateRequest
    ): Observable<RequiredDesignFileTemplateResponse> {
        return this._httpClient.put<RequiredDesignFileTemplateResponse>(
            `${basePath}/${id}`,
            model
        );
    }

    setActive(id: number, isActive: boolean): Observable<RequiredDesignFileTemplateResponse> {
        return this._httpClient.patch<RequiredDesignFileTemplateResponse>(
            `${basePath}/${id}/active`,
            isActive
        );
    }

    delete(id: number): Observable<void> {
        return this._httpClient.delete<void>(`${basePath}/${id}`);
    }

    previewMatch(
        model: RequiredDesignFileTemplatePreviewMatchRequest
    ): Observable<RequiredDesignFileTemplatePreviewMatchResult> {
        return this._httpClient.post<RequiredDesignFileTemplatePreviewMatchResult>(
            `${basePath}/preview-match`,
            model
        );
    }
}
